import produce from "immer"
import { MarkovRedistribution } from "server/models"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

export const initMarkovRedistribution: MarkovRedistribution = {
    id: null,
    modelId: null,
    name: "",
    periodic: false,
    time: "",
    order: 0,
}

const initMarkovRedistributionState: types.MarkovRedistributionState = {
    redistributions: [],
    redistributionSelected: null,
    redistributionEdit: initMarkovRedistribution,

    reloadList: true,
    reloadEdit: true,
}

const markovRedistributionReducer = produce((
    draft: types.MarkovRedistributionState = initMarkovRedistributionState,
    action: ActionTypes = null,
): types.MarkovRedistributionState => {
    switch (action.type) {
        case types.MARKOV_REDISTRIBUTIONS:
            draft.redistributions = action.redistributions
            return draft

        case types.MARKOV_REDISTRIBUTION_SELECTED:
            draft.redistributionSelected = action.redistribution
            return draft

        case types.MARKOV_REDISTRIBUTION_EDIT:
            draft.redistributionEdit = action.redistribution
            return draft

        case types.MARKOV_REDISTRIBUTION_RELOAD_LIST:
            draft.reloadList = action.value
            return draft

        case types.MARKOV_REDISTRIBUTION_RELOAD_EDIT:
            draft.reloadEdit = action.value
            return draft

        default:
            return draft
    }
})
export default markovRedistributionReducer
